module.exports = __webpack_public_path__ + "static/media/invoice-onboarding-store.db4633a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/invoice-onboarding-store.png
// module id = 649
// module chunks = 8